import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { VEHICULE_URL } from "../../settings/APISetting";
import { sortByProp } from "../../settings/themeSettings";
import api from "../../config/axiosConfig";



export const fetchVehicules = createAsyncThunk('fetch-vehicules', async (page = 1) => {
    const response = await api.get(VEHICULE_URL);
    return response.data;
});

export const createVehicule = (vehicule, err, cb) => {
    api.post(VEHICULE_URL, vehicule)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const updateVehicule = (vehicule, err, cb) => {
    api.put(`${VEHICULE_URL}/${vehicule.id}`, vehicule)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const deleteVehicule = (id, err, cb) => {
    api.delete(`${VEHICULE_URL}/${id}`)
        .then((response) => {
            if (cb) cb(response);
        })
        .catch((error) => {
            if (err) err(error);
        });
}






const vehiculeSlice = createSlice({

    name: 'vehicules',
    initialState: { vehicules: [], vehiculeFetchStatus: '' },

    reducers: {
        addVehicule: (state, action) => {
            state.vehicules = [...state.vehicules, action.payload].sort((a,b) => sortByProp(a,b,'modele'));
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchVehicules.fulfilled, (state, action) => {
            if (Array.isArray(action.payload)) {
                state.vehicules = [...action.payload].sort((a, b) => sortByProp(a, b, 'modele'));
                state.vehiculeFetchStatus = 'success';
            } else {
                console.error("fetchVehicules payload is not an array:", action.payload);
                state.vehicules = [];
                state.vehiculeFetchStatus = 'error';
            }
        }).addCase(fetchVehicules.pending, (state, action) => {
            state.vehiculeFetchStatus = 'loading';

        }).addCase(fetchVehicules.rejected, (state, action) => {

            state.vehiculeFetchStatus = 'error';

        });
    }


});
export const { addVehicule } = vehiculeSlice.actions;
export default vehiculeSlice;